(function () {
  const REDUCED_MOTION = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const money = (cents) => {
    try { return new Intl.NumberFormat('en-GB', { style: 'currency', currency: 'GBP' }).format((cents || 0) / 100); }
    catch (e) { return '£' + ((cents || 0) / 100).toFixed(2); }
  };

  function qs(sel, root = document) { return root.querySelector(sel); }
  function qsa(sel, root = document) { return Array.from(root.querySelectorAll(sel)); }

  function escapeHtml(str) {
    return String(str || '').replace(/[&<>'"]/g, tag => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', "'": '&#39;', '"': '&quot;' }[tag]));
  }

  function updateCartCount(count) {
    qsa('[data-cart-count]').forEach(el => { el.textContent = count || 0; });
  }

  function showToast(message) {
    const toast = qs('[data-toast]');
    if (!toast) return;
    toast.textContent = message || 'Added to basket';
    toast.classList.add('is-visible');
    clearTimeout(window.__toastTimer);
    window.__toastTimer = setTimeout(() => toast.classList.remove('is-visible'), 2600);
  }

  /* ---------- Cart drawer (focus-managed dialog) ---------- */
  let lastFocused = null;

  function openCartDrawer() {
    const drawer = qs('[data-cart-drawer]');
    if (!drawer) return;
    lastFocused = document.activeElement;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('drawer-open');
    const closeBtn = qs('.cart-drawer__close', drawer);
    if (closeBtn) closeBtn.focus();
  }

  function closeCartDrawer() {
    const drawer = qs('[data-cart-drawer]');
    if (!drawer || !drawer.classList.contains('is-open')) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('drawer-open');
    if (lastFocused && typeof lastFocused.focus === 'function') lastFocused.focus();
    lastFocused = null;
  }

  // Keep keyboard focus inside the drawer while it is open
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      closeCartDrawer();
      closeMobileMenu();
      return;
    }
    if (e.key !== 'Tab') return;
    const drawer = qs('[data-cart-drawer].is-open');
    if (!drawer) return;
    const focusables = qsa('a[href], button:not([disabled]), input, select, textarea, [tabindex]:not([tabindex="-1"])', drawer)
      .filter(el => el.offsetParent !== null);
    if (!focusables.length) return;
    const first = focusables[0];
    const last = focusables[focusables.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  });

  async function refreshCartDrawer(openAfter = false) {
    try {
      const res = await fetch('/cart.js', { headers: { 'Accept': 'application/json' } });
      const cart = await res.json();
      updateCartCount(cart.item_count);
      const body = qs('[data-cart-drawer-body]');
      const subtotal = qs('[data-cart-subtotal]');
      if (subtotal) subtotal.textContent = money(cart.total_price);
      if (body) {
        if (!cart.items.length) {
          body.innerHTML = '<div class="empty-state"><h3>Your basket is empty</h3><p>Begin your journey of beneficial knowledge.</p><a class="button" href="/collections/all">Explore books</a></div>';
        } else {
          body.innerHTML = cart.items.map(item => `
            <div class="cart-drawer-item">
              ${item.image ? `<img src="${item.image.includes('?') ? item.image + '&width=132' : item.image}" alt="" loading="lazy">` : '<div></div>'}
              <div class="cart-drawer-item__details">
                <strong>${escapeHtml(item.product_title)}</strong>
                ${item.variant_title && item.variant_title !== 'Default Title' ? `<div class="muted">${escapeHtml(item.variant_title)}</div>` : ''}
                <div class="muted">Qty ${item.quantity}</div>
                <div class="cart-drawer-item__price">${money(item.final_line_price)}</div>
              </div>
              <button type="button" class="cart-remove-button" data-remove-key="${item.key}" aria-label="Remove ${escapeHtml(item.product_title)} from basket">Remove</button>
            </div>
          `).join('');
        }
      }
      if (openAfter) openCartDrawer();
    } catch (e) {
      console.error('Cart refresh failed', e);
    }
  }

  /* ---------- Mobile menu ---------- */
  function setMobileMenu(open) {
    const menu = qs('[data-mobile-menu]');
    const toggle = qs('[data-mobile-toggle]');
    if (!menu || !toggle) return;
    menu.classList.toggle('is-open', open);
    toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    toggle.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');
    toggle.classList.toggle('is-open', open);
  }
  function closeMobileMenu() { setMobileMenu(false); }

  qsa('[data-mobile-toggle]').forEach(btn => btn.addEventListener('click', () => {
    const menu = qs('[data-mobile-menu]');
    setMobileMenu(!(menu && menu.classList.contains('is-open')));
  }));

  // Close menu after choosing a destination
  const mobileMenu = qs('[data-mobile-menu]');
  if (mobileMenu) mobileMenu.addEventListener('click', (e) => { if (e.target.closest('a')) closeMobileMenu(); });

  /* ---------- Global click handling ---------- */
  document.addEventListener('click', async (event) => {
    if (event.target.closest('[data-cart-close]')) closeCartDrawer();

    const open = event.target.closest('[data-cart-open]');
    if (open) {
      event.preventDefault();
      await refreshCartDrawer(true);
    }

    const remove = event.target.closest('[data-remove-key]');
    if (remove) {
      event.preventDefault();
      remove.disabled = true;
      remove.textContent = 'Removing…';
      try {
        await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: remove.dataset.removeKey, quantity: 0 })
        });
      } catch (e) { console.error(e); }
      await refreshCartDrawer(false);
    }

    const next = event.target.closest('[data-hero-next]');
    const prev = event.target.closest('[data-hero-prev]');
    if (next || prev) {
      const section = event.target.closest('[data-hero-carousel]');
      if (section) { stopHeroAutoplay(section); stepHero(section, next ? 1 : -1); }
    }

    const dot = event.target.closest('[data-hero-index]');
    if (dot) {
      const section = event.target.closest('[data-hero-carousel]');
      if (section) { stopHeroAutoplay(section); setHero(section, Number(dot.dataset.heroIndex)); }
    }

    const carNext = event.target.closest('[data-carousel-next]');
    const carPrev = event.target.closest('[data-carousel-prev]');
    if (carNext || carPrev) {
      const wrap = event.target.closest('[data-product-carousel-wrap]');
      const rail = wrap && qs('[data-product-carousel]', wrap);
      if (rail) rail.scrollBy({ left: (carNext ? 1 : -1) * rail.clientWidth * .85, behavior: REDUCED_MOTION ? 'auto' : 'smooth' });
    }

    // Product gallery thumbnails
    const thumb = event.target.closest('[data-thumb]');
    if (thumb) {
      const section = thumb.closest('[data-product-section]');
      const main = section && qs('[data-main-image]', section);
      if (main && thumb.dataset.fullSrc) {
        main.src = thumb.dataset.fullSrc;
        main.removeAttribute('srcset');
        const thumbImg = thumb.querySelector('img');
        if (thumbImg && thumbImg.alt) main.alt = thumbImg.alt;
        qsa('[data-thumb]', section).forEach(t => t.classList.toggle('is-active', t === thumb));
      }
    }
  });

  /* ---------- AJAX add to basket ---------- */
  document.addEventListener('submit', async (event) => {
    const form = event.target.closest('form[action*="/cart/add"]');
    if (!form) return;
    if (form.dataset.noAjax === 'true') return;
    event.preventDefault();
    const buttons = qsa('[type="submit"]', form);
    const oldText = buttons.length ? buttons[0].textContent : '';
    try {
      buttons.forEach(b => { b.disabled = true; b.textContent = 'Adding…'; });
      const formData = new FormData(form);
      const res = await fetch('/cart/add.js', { method: 'POST', body: formData, headers: { 'Accept': 'application/json' } });
      if (!res.ok) {
        let msg = 'Could not add item. Check stock and try again.';
        try { const err = await res.json(); if (err && err.description) msg = err.description; } catch (e) {}
        throw new Error(msg);
      }
      await refreshCartDrawer(true);
      showToast('Added to basket');
    } catch (e) {
      showToast(e.message || 'Could not add item. Check stock and try again.');
      console.error(e);
    } finally {
      buttons.forEach(b => { b.disabled = false; b.textContent = oldText; });
    }
  });

  /* ---------- Product variant picker ---------- */
  qsa('[data-variant-select]').forEach(select => {
    const section = select.closest('[data-product-section]');
    const jsonTag = section && qs('[data-variant-json]', section);
    if (!jsonTag) return;
    let variants = [];
    try { variants = JSON.parse(jsonTag.textContent); } catch (e) { return; }
    select.addEventListener('change', () => {
      const variant = variants.find(v => String(v.id) === select.value);
      if (!variant) return;
      qsa('[data-product-price]', section).forEach(el => { el.textContent = money(variant.price); });
      const sku = qs('[data-product-sku]', section);
      if (sku && variant.sku) sku.textContent = variant.sku;
      const stock = qs('[data-stock-status]', section);
      if (stock) {
        stock.textContent = variant.available ? 'In stock' : 'Out of stock';
        stock.classList.toggle('in-stock', variant.available);
        stock.classList.toggle('out-stock', !variant.available);
      }
      qsa('[data-add-to-cart]', section).forEach(btn => {
        btn.disabled = !variant.available;
        btn.textContent = variant.available ? 'Add to Basket' : 'Sold out';
      });
      const main = qs('[data-main-image]', section);
      if (main && variant.featured_image && variant.featured_image.src) {
        main.src = variant.featured_image.src;
        main.removeAttribute('srcset');
      }
    });
  });

  /* ---------- Hero carousel ---------- */
  function setHero(section, index) {
    const slides = qsa('[data-hero-slide]', section);
    const dots = qsa('[data-hero-index]', section);
    if (!slides.length) return;
    const next = (index + slides.length) % slides.length;
    slides.forEach((slide, i) => slide.classList.toggle('is-active', i === next));
    dots.forEach((dot, i) => {
      dot.classList.toggle('is-active', i === next);
      dot.setAttribute('aria-current', i === next ? 'true' : 'false');
    });
    section.dataset.activeSlide = next;
  }
  function stepHero(section, dir) { setHero(section, Number(section.dataset.activeSlide || 0) + dir); }

  function stopHeroAutoplay(section) {
    if (section.__heroTimer) { clearInterval(section.__heroTimer); section.__heroTimer = null; }
    section.__heroStopped = true;
  }

  qsa('[data-hero-carousel]').forEach(section => {
    setHero(section, 0);

    // Swipe navigation on touch devices
    let touchX = 0, touchY = 0;
    section.addEventListener('touchstart', (e) => {
      touchX = e.changedTouches[0].clientX;
      touchY = e.changedTouches[0].clientY;
    }, { passive: true });
    section.addEventListener('touchend', (e) => {
      const dx = e.changedTouches[0].clientX - touchX;
      const dy = e.changedTouches[0].clientY - touchY;
      if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy)) {
        stopHeroAutoplay(section);
        stepHero(section, dx < 0 ? 1 : -1);
      }
    }, { passive: true });
    const speed = Number(section.dataset.autoplay || 0);
    if (speed > 0 && !REDUCED_MOTION) {
      const start = () => {
        if (section.__heroStopped || section.__heroTimer) return;
        section.__heroTimer = setInterval(() => stepHero(section, 1), speed);
      };
      const pause = () => { if (section.__heroTimer) { clearInterval(section.__heroTimer); section.__heroTimer = null; } };
      section.addEventListener('mouseenter', pause);
      section.addEventListener('mouseleave', start);
      section.addEventListener('focusin', pause);
      section.addEventListener('focusout', (e) => { if (!section.contains(e.relatedTarget)) start(); });
      document.addEventListener('visibilitychange', () => { document.hidden ? pause() : start(); });
      start();
    }
  });

  refreshCartDrawer(false);
})();
